import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IItem, ISection } from '../../models/group-edit-config';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-group-edit-section',
  templateUrl: './group-edit-section.component.html',
  styleUrls: ['./group-edit-section.component.scss']
})
export class GroupEditSectionComponent implements OnInit, OnChanges {
    @Input() section: ISection;
    @Input() selectedSection: ISection;
    @Input() dialogMode: boolean = false;
    @Input() form: FormGroup;
    @Input() subSection: boolean = false;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['section']) {
            console.log("GroupEditSectionComponent section changed...", this.section);
        }
    }

    @Output() sectionEditing = new EventEmitter<ISection>();
    constructor() { }

    ngOnInit(): void {
    }

    async saveSection(){
        if(this.section.completedAction){
            const res = await this.section.completedAction(this.section);
            if(res){
                this.sectionEditing.emit(null);
            }
        }else{
            this.sectionEditing.emit(null);
        }
    }
    
    cancelledSection(){
        this.sectionEditing.emit(null);
    }

    editSection(){
        this.sectionEditing.emit(this.section);
    }

    
}
